import Layout from "@/components/layout/index.vue";
//权限管理
export default [{
    path: "/",
    name: "contentLayout",
    component: Layout,
    meta: {
        title: "内容中心"
    },
    children: [{
            path: '/verbal',
            name: 'verbal',
            meta: {
                title: "话术管理"
            },
            component: () =>
                import ('@/views/verbal/verbal.vue'),
        },
        {
            path: '/fodder',
            name: 'fodder',
            meta: {
                title: "素材库"
            },
            component: () =>
                import ('@/views/fodder/index.vue'),
        },
    ]
}];